module.exports = __webpack_public_path__ + "media/images/emblems/Giez-coat_of_arms-1741b15a030cedf05c7512699361bb97.svg";